import React, { FC } from 'react';

import classes from './classes.module.css';

interface TitleProps {
  children: React.ReactNode;
}

const Title: FC<TitleProps> = ({ children }) => {
  return <h1 className={classes.container}>{children}</h1>;
};

export default Title;
